import { render, staticRenderFns } from "./classCreate.vue?vue&type=template&id=1f89dac7&"
import script from "./classCreate.vue?vue&type=script&lang=js&"
export * from "./classCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports